module.exports = __webpack_public_path__ + "static/img/06.0288d67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour3/06.jpg
// module id = zDie
// module chunks = 0